export default import.meta.ROLLDOWN_FILE_URL_ujGp$gi5kRfgY_zCHF78LQ